import type { DisplayGroupLayout } from './displayGroupLayout'
import {
  charactersEqual,
  getBoardSliceFromParentMessage
} from './splitMessageForDisplayGroup'
import type { MessageAppearanceRow, NoAppearanceReason, ParentFanoutRecord } from './types'

export const inferNoAppearanceReason = ({
  boardId,
  parent,
  previousParent,
  layout
}: {
  boardId: string
  parent: MessageAppearanceRow
  previousParent: MessageAppearanceRow | null
  layout: DisplayGroupLayout
}): NoAppearanceReason => {
  if (!previousParent) return null

  const currentSlice = getBoardSliceFromParentMessage(parent.message?.characters, layout, boardId)
  const previousSlice = getBoardSliceFromParentMessage(previousParent.message?.characters, layout, boardId)
  if (!currentSlice || !previousSlice) return null

  return charactersEqual(currentSlice.characters, previousSlice.characters) ? 'no_content_changed' : null
}

export const applyNoAppearanceReasons = (
  records: ParentFanoutRecord[],
  layout: DisplayGroupLayout | null
): ParentFanoutRecord[] => {
  if (!layout || records.length === 0) return records

  const sorted = [...records].sort((a, b) => b.parent.created - a.parent.created)

  return sorted.map((record, index) => {
    const previousParent = sorted[index + 1]?.parent ?? null
    const rows = record.rows.map(row => {
      if (row.matchedAppearance || row.coverageStatus !== 'complete') {
        return { ...row, noAppearanceReason: null as NoAppearanceReason }
      }

      return {
        ...row,
        noAppearanceReason: inferNoAppearanceReason({
          boardId: row.board.id,
          parent: record.parent,
          previousParent,
          layout
        })
      }
    })

    return { ...record, rows }
  })
}
